import { Icon } from './types';

export const LocationIcon: Icon = (props) => (
  <svg viewBox={'0 0 24 24'} {...props}>
    <path
      d={
        'M15.75 9.092a3.754 3.754 0 01-3.75 3.76 3.754 3.754 0 01-3.75-3.76A3.754 3.754 0 0112 5.332a3.754 3.754 0 013.75 3.76zM12 11.348c1.242 0 2.25-1.01 2.25-2.256A2.253 2.253 0 0012 6.836a2.253 2.253 0 00-2.25 2.256A2.254 2.254 0 0012 11.348zm9-2.256c0 4.108-5.484 11.42-7.89 14.438a1.414 1.414 0 01-2.22 0C8.441 20.512 3 13.2 3 9.092 3 4.11 7.03.07 12 .07c4.969 0 9 4.04 9 9.023zm-9-7.52c-4.144 0-7.5 3.366-7.5 7.52 0 .733.255 1.74.776 2.98.512 1.217 1.23 2.538 2.043 3.858 1.597 2.6 3.49 5.085 4.681 6.585 1.19-1.5 3.084-3.986 4.683-6.585.81-1.32 1.528-2.64 2.039-3.858.525-1.24.778-2.247.778-2.98 0-4.154-3.356-7.52-7.5-7.52z'
      }
    />
  </svg>
);
